// The design language, in one place.
//
// Every colour, font and radius the platform uses is named here and nowhere
// else. The previous UI hardcoded hexes at ~40 call sites across the landing,
// the shell and the panels, which is why it drifted into three different greys
// and two different blues. If a value isn't in this file, it shouldn't be in a
// component.
//
// Source: the "Vibe cloud" design system (Landing Page.dc.html,
// Console.dc.html).

export const c = {
	/** Page background — warm off-white, not pure #fff. */
	bg: "#FCFCFA",
	/** Recessed surface: strips, table headers, the second plane. */
	bgAlt: "#F7F7F3",
	/** Hover wash on light surfaces. */
	bgHover: "#F2F2ED",

	/** Primary text. Near-black with a blue cast, never pure #000. */
	ink: "#14141F",
	/** Secondary text: descriptions, table cells. */
	muted: "#5C5C66",
	/** Tertiary: timestamps, hints, monospace furniture. */
	faint: "#9C9CA3",

	border: "#E2E2DC",
	borderStrong: "#D6D6CF",

	/** The one accent. Used for action, focus, and *nothing decorative*. */
	blue: "#1B4FFF",
	blueHover: "#143CCC",
	blueTint: "#F0F3FF",
	blueBorder: "#D6DEFF",
	/** Blue that survives on the dark panel. */
	blueOnDark: "#7C97FF",

	green: "#16B364",

	/** The dark panel — terminals, prompt boxes, code. The product's one
	 *  moment of contrast; used sparingly so it keeps its weight. */
	dark: "#14141F",
	darkRaised: "#1E1E2A",
	darkBorder: "#26262F",
	darkBorderRaised: "#34344A",
	darkInk: "#EDEDEF",
	darkMuted: "#8A8A96",
	darkFaint: "#6E6E7A",
} as const;

export const font = {
	/** Display + UI. Variable optical sizing; 800 for headlines. */
	sans: "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif",
	/** Code, ids, URLs, and anything the machine wrote. */
	mono: "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
} as const;

export const radius = {
	/** Pills: every button and tag. The design has no square buttons. */
	pill: 999,
	card: 16,
	panel: 14,
	input: 10,
	chip: 8,
} as const;

/** Tracking. Headlines are tight; the bigger they get, the tighter they go. */
export const tracking = {
	hero: "-0.035em",
	h2: "-0.03em",
	h3: "-0.02em",
} as const;

/** The uppercase monospace kicker used above panels ("PASTE INTO YOUR AGENT"). */
export const kicker = {
	fontFamily: font.mono,
	fontSize: 11,
	letterSpacing: "0.08em",
	textTransform: "uppercase" as const,
	color: c.faint,
};

export const shadow = {
	panel: "0 12px 40px rgba(20,20,31,0.14)",
	panelStrong: "0 12px 40px rgba(20,20,31,0.18)",
} as const;
